module.exports = __webpack_public_path__ + "static/media/outline-icons.ad97afd3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/outline-icons.ttf
// module id = ./src/styling/theme/assets/fonts/outline-icons.ttf
// module chunks = 0